import { DateTypeEnum } from './date-type-enum'
import { SelectTypeEnum } from './select-type-enum'

export interface MeteDataResInterface {
  /**
   * 多选类型里表示最多可选择多少个，文件类型表示最多上传文件的个数
   */
  maxCount?: number
  /**
   * 多选类型里表示最少可选择多少个，文件类型表示最少上传文件的个数
   */
  minCount?: number
  /**
   * 附件类型文件上传大小限制
   */
  fileSizeLimit?: number
  /**
   * 是否显示题目说明
   */
  showDescription?: boolean
  /**
   * 数字类型精确到小数点后几位
   */
  precision?: number
  /**
   * 日期类型
   */
  dateType?: DateTypeEnum
  /**
   * 单选多选类型 添加其他选项后是否必填
   */
  otherRequire?: boolean
  /**
   * 单选多选 显示类型
   */
  selectType?: SelectTypeEnum
  /**
   * 原始name
   */
  originLabel?: string
}

export class MeteDataRes implements MeteDataResInterface {
  /**
   * 多选类型里表示最多可选择多少个，文件类型表示最多上传文件的个数
   */
  maxCount?: number
  /**
   * 多选类型里表示最少可选择多少个，文件类型表示最少上传文件的个数
   */
  minCount?: number
  /**
   * 附件类型文件上传大小限制
   */
  fileSizeLimit?: number
  /**
   * 是否显示题目说明
   */
  showDescription?: boolean
  /**
   * 数字类型精确到小数点后几位
   */
  precision?: number
  /**
   * 日期类型
   */
  dateType?: DateTypeEnum
  /**
   * 单选多选类型 添加其他选项后是否必填
   */
  otherRequire?: boolean
  /**
   * 单选多选 显示类型
   */
  selectType?: SelectTypeEnum
  /**
   * 原始name
   */
  originLabel?: string

  constructor(props: MeteDataResInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      maxCount: _maxCount,
      minCount: _minCount,
      fileSizeLimit: _fileSizeLimit,
      showDescription: _showDescription,
      precision: _precision,
      dateType: _dateType,
      otherRequire: _otherRequire,
      selectType: _selectType,
      originLabel: _originLabel,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.maxCount = _maxCount
    this.minCount = _minCount
    this.fileSizeLimit = _fileSizeLimit
    this.showDescription = _showDescription
    this.precision = _precision
    this.dateType = _dateType
    this.otherRequire = _otherRequire
    this.selectType = _selectType
    this.originLabel = _originLabel
  }
}
